import { configureStore } from "@reduxjs/toolkit";
import { ageReducer } from "./ageState";
import { genreReducer } from "./genreState";
import { languageReducer } from "./languageState";
import { sourceReducer } from "./source";
import { bookReducer } from "./book";

export const Store = configureStore({
  reducer: {
    Age: ageReducer,
    Genre: genreReducer,
    Language: languageReducer,
    Source: sourceReducer,
    Book: bookReducer,
  },
});
